import React from "react";
import { Text, View, StyleSheet, Image } from "@react-pdf/renderer";
import PdfInformation from "./pdf-information";
import PdfIdentificationCertification from "./pdf-identification-certification";
import PdfApplicantCertification from "./pdf-applicant-certification";

interface EifSectionProps {
  applicantId: string;
  caseId: string;
  nameOnDocument: string;
  dateOfBirth: string;
  gender: string;
  photoBlobUrl: string;
  passportBlobUrl: string;
}


export const PdfEIFSection: React.FC<EifSectionProps> = (props) => {  
  const styles = StyleSheet.create({
    text: {
      fontSize: "7px",
    },
    mainSection: {
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "center",
      paddingRight: 10,
      paddingLeft: 10,
      width: "100%",
      marginBottom: "10px"
    },
    rowContainer: {
      flexDirection: "row",
      justifyContent: "space-between",
    },
    row: {
      width: "60%",
      marginRight: "10px",
    },
    imageInstruction: {
      fontSize: 10,
      textAlign: "center",
      color: "black",
    },
    imagePhoto: {
      width: "90px", // Adjusted width to maintain 1:1 ratio
      height: "90px", // Reduced height by 10% to match format provided in example image
    },
    imagePassport: {
      width: "255.7px", // Adjusted width to maintain aspect ratio
      height: "342.2px", // Reduced height by another 10% to prevent passport from overflowing
    },
  });

  return (
    <View style={styles.mainSection}>
      <View style={styles.row}>
        <PdfInformation applicantId={props.applicantId} caseId={props.caseId} nameOnDocument={props.nameOnDocument} dateOfBirth={props.dateOfBirth} gender={props.gender}/>
        <PdfIdentificationCertification data={props.applicantId} />
        <PdfApplicantCertification data={props.applicantId}/>
      </View>
      <View>
        <View style={styles.rowContainer}>
          <View id="left" style={{ alignSelf: "flex-start" }}>
            <Image style={styles.imagePhoto} src={props.photoBlobUrl} />
          </View>
          <View id="right" style={{ alignSelf: "flex-end", maxWidth: "80px", paddingRight: 20 }}>
            <Text style={{ ...styles.imageInstruction, fontSize: "7px" }} wrap>
              Official: Seal/stamp must cover a portion of the photo and of the passport.{"\n\n\n\n\n"}
            </Text>
          </View>
        </View>
        <View style={{ height: 10 }} />
        <Image style={styles.imagePassport} src={props.passportBlobUrl} />
      </View>
    </View>
  );
};
export default PdfEIFSection;
